import { combineReducers } from "redux";
import Auth from "./auth/reducer";
import Users from "./users/reducer";
import Roles from "./roles/reducer";
import Vendors from "./vendors/reducer";
import ChannelPartners from "./channelPartners/reducer";
import DataCategories from "./dataCategories/reducer";
import Projects from "./projects/reducer";
import LeadSources from "./leadSources/reducer";
import Uploads from "./uploads/reducer";
import Permissions from "./permissions/reducer";
import Dashboard from "./dashboard/reducer";
import PowerBI from "./powerbi/reducer";
import Clusters from "./cluster/reducer";
import Extractions from "./extractions/reducer";
import ExtDataGroups from "./extDataGroups/reducer";
import ExtDataCategories from "./extDataCategories/reducer";
import ExtExclusions from "./extExclusions/reducer";
import ExtCustomColumns from "./extCustomColumns/reducer";
import ExtCustomColumnQueries from "./extCustomColumnQueries/reducer";
import ExtVersions from "./extVersions/reducer";
import ExtOutputMappings from "./extOutputMappings/reducer";
import MultiChannelCampaigns from "./mcc/reducer";


const rootReducer = combineReducers({
  Auth,
  Users,
  Permissions,
  Vendors,
  ChannelPartners,
  DataCategories,
  Projects,
  LeadSources,
  Roles,
  Uploads,
  Dashboard,
  PowerBI,
  Clusters,
  Extractions,
  ExtDataGroups,
  ExtDataCategories,
  ExtExclusions,
  ExtCustomColumns,
  ExtCustomColumnQueries,
  ExtVersions,
  ExtOutputMappings,
  MultiChannelCampaigns,
});

export default rootReducer;
